import styled from 'styled-components';
import { colorWhite } from '@/utils/palette';
import { Button } from '@/shared/components/Button';
import { Link } from 'react-router';

const NotFound404 = () => (
    <NotFoundContainer>
        <NotFountContent>
            <NotFoundTitle>404</NotFoundTitle>
            <NotFoundInfo>Ooops! The page you are looking for could not be found :(</NotFoundInfo>
            <Button as={Link} variant="primary" to="/users">
                Back to Dashboard
            </Button>
        </NotFountContent>
    </NotFoundContainer>
);

export default NotFound404;

const NotFoundContainer = styled.div`
    text-align: center;
    height: 100vh;
    overflow: auto;
    display: flex;

    button {
        margin: 0;
    }
`;

const NotFountContent = styled.div`
    margin: auto;
    padding: 10px;
`;

const NotFoundTitle = styled.h2`
    color: ${colorWhite};
    margin-bottom: 20px;
    margin-top: 90px;
`;

const NotFoundInfo = styled.h3`
    color: ${colorWhite};
    margin-bottom: 20px;
    margin-top: 90px;
`;
